import { Spin } from "antd";
import styled from "styled-components";

export const SpinStyled = styled(Spin)`
  &&& {
    max-height: unset;
    position: fixed;
  }
`;
